import {Delete24Regular, Play24Filled} from "@fluentui/react-icons";
import {FC} from "react";
import IntelligenceGlyph from "./IntelligenceGlyph";
import {SavedPrompt} from "./intelligenceModels";

interface IntelligenceSavedViewProps {
    prompts: SavedPrompt[];
    onRun: (prompt: SavedPrompt) => void;
    onDelete: (id: string) => void;
}

const IntelligenceSavedView: FC<IntelligenceSavedViewProps> = ({
    prompts,
    onRun,
    onDelete
}) => (
    <div className="pi-scroll">
        <div className="pi-view-head">
            <h2 className="pi-view-head__title">Saved prompts</h2>
            <p className="pi-view-head__desc">
                Your reusable prompts, ready to run in one click.
            </p>
        </div>

        {prompts.map((prompt) => (
            <div className="pi-saved-card" key={prompt.id}>
                <span className="pi-saved-card__icon">
                    <IntelligenceGlyph icon={prompt.icon} />
                </span>
                <div className="pi-saved-card__body">
                    <span className="pi-saved-card__category">
                        {prompt.category}
                    </span>
                    <div className="pi-saved-card__title">{prompt.title}</div>
                    <div className="pi-saved-card__prompt">{prompt.prompt}</div>
                    <div className="pi-saved-card__actions">
                        <button
                            type="button"
                            className="pi-btn pi-btn--primary"
                            onClick={() => onRun(prompt)}
                        >
                            <Play24Filled />
                            Run
                        </button>
                        <button
                            type="button"
                            className="pi-btn pi-btn--danger"
                            onClick={() => onDelete(prompt.id)}
                        >
                            <Delete24Regular />
                            Remove
                        </button>
                    </div>
                </div>
            </div>
        ))}
    </div>
);

export default IntelligenceSavedView;
